import { render, staticRenderFns } from "./EditChartGlobalConfig.vue?vue&type=template&id=351fb27a"
import script from "./EditChartGlobalConfig.vue?vue&type=script&lang=js"
export * from "./EditChartGlobalConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports